// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3YTs7","footer":"ModalInfo_footer__8RNvZ"};